<template>
  <AppLink
    :to="item.product.product.url"
    class="compare-list__product-link"
  >
    <img
      class="compare-list__image"
      :src="getProductImage(item.product.product.image, 'f=rs:fit:80')"
      :alt="item.product.product.name"
      width="80"
      height="80"
      loading="lazy"
      fetchpriority="low"
      decoding="async"
    >
    <div class="compare-list__details">
      <span class="compare-list__brand">{{ item.product.product.brand.label }}</span>
      <span class="compare-list__name">{{ item.product.product.name }}</span>
      <!-- <ProductPrice
        class="compare-list__price"
        :prices="{
          regularPrice: item.product.product.regularPrice,
          finalPrice: item.product.product.finalPrice,
        }"
        :show-vat-tag="false"
      /> -->
    </div>
  </AppLink>
</template>

<script setup lang="ts">
interface Props {
  item: {
    product: {
      product: {
        url: string
        image: string
        name: string
        brand: {
          label: string
        }
        regularPrice: number
        finalPrice: number
      }
    }
  }
}

defineProps<Props>()
</script>
